/**
 * Canonical form of a workspace-variable reference:
 * ``$workspace/<variable_name>``. Must match the regex on the backend
 * (`spotflow.integrations.workspace_refs`).
 */
const WORKSPACE_REF_RE = /^\$workspace\/([A-Za-z_][A-Za-z0-9_]*)$/;

export function parseWorkspaceRef(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const m = value.match(WORKSPACE_REF_RE);
  return m ? m[1] : null;
}

export function formatWorkspaceRef(variableName: string): string {
  return `$workspace/${variableName}`;
}

export function isWorkspaceRef(value: unknown): boolean {
  return parseWorkspaceRef(value) !== null;
}
